import { TabsProps } from 'antd';
import type { CardTabListType } from 'antd/es/card';
import { useLayoutEffect } from 'react';
import { AdminRichTab } from '../RichPageLayout';

export const CorePageLayoutTabsPrefix = 'page-layout-tabs__';

/**
 * Rimuoviamo il tabIndex del contenuto dei tab (in realtà ne abbiamo sempre
 * due: uno per la barra di navigazione nell'header e uno per il contenuto
 * effettivo (usato solo in Admin, in Backoffice il contenuto effettivo è
 * fuori dal tabPanel)
 * 1. Per il backoffice, è necessario rimuovere il tabIndex da entrambi
 * 2. Per admin, lo rimuoviamo comunque perché è un tabStop "scomodo"
 */
export function useTabsTabIndexReset(
  tabs:
    | AdminRichTab[]
    | null
    | undefined
    | TabsProps['items']
    | CardTabListType[],
  activeTab: string,
  prefix: string = CorePageLayoutTabsPrefix,
) {
  useLayoutEffect(() => {
    // Utilizziamo un delay per esseri sicuri che i tab
    // siano stati renderizzati
    setTimeout(() => {
      try {
        // Selezioniamo tutti i tabPanel (_solo_ del nostro CorePageLayout)
        // e rimuoviamo il tabIndex
        const tabsSelector = `div[id^="${prefix}"][role="tabpanel"]`;

        document.querySelectorAll(tabsSelector).forEach(el => {
          el.setAttribute('tabindex', '-1');
        });
      } catch (e) {
        console.error('Error setting tabindex on tabs', e);
      }
    }, 50);
  }, [tabs, activeTab, prefix]);
}
